export default __webpack_public_path__ + "static/media/alert.d6382b72.svg";